import { AutoComplete as AntAutoComplete } from 'antd'
import type { ComponentProps } from 'react'
import { SIZE_MAP } from '../types'
import type { Size } from '../types'

type AntAutoCompleteProps = ComponentProps<typeof AntAutoComplete>

export interface AppAutoCompleteProps extends Omit<AntAutoCompleteProps, 'size'> {
  size?: Size
}

export const AppAutoComplete = ({ size = 'md', ...rest }: AppAutoCompleteProps) => (
  <AntAutoComplete size={SIZE_MAP[size]} {...rest} />
)
